import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["name", "selected"]

import {useSortingStore} from "@/store/SerpPage/SortingStore";
import {onMounted, toRefs} from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SortingButton',
  setup(__props) {

const sortingStore = useSortingStore();
const {selectedSort} = toRefs(sortingStore)

onMounted(() => {
  sortingStore.fetchSortingOptions()
  selectedSort.value = sortingStore.getSelectedSortFromUrl()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("select", {
    id: "sortingButtons",
    class: "sorting-buttons q-form-select q-rounded-3 q-shadow-sm q-border-0",
    "aria-label": "Sorting select options",
    onChange: _cache[0] || (_cache[0] = ($event: any) => (_unref(sortingStore).updateSorting($event)))
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sortingStore).sort, (sort) => {
      return (_openBlock(), _createElementBlock("option", {
        name: sort.id,
        key: sort.id,
        selected: sort.id === _unref(selectedSort)
      }, _toDisplayString(sort.label), 9, _hoisted_1))
    }), 128))
  ], 32))
}
}

})